#version 300 es

precision highp float;

// Full screen quad vertices
const vec2 positions[6] = vec2[6](
    vec2(-1.0, -1.0),
    vec2( 1.0, -1.0),
    vec2( 1.0,  1.0),
    vec2(-1.0, -1.0),
    vec2( 1.0,  1.0),
    vec2(-1.0,  1.0)
);

out vec2 vUv;

void main() {
    vec2 position = positions[gl_VertexID];
    gl_Position = vec4(position, 0.0, 1.0);
    
    // Convert from clip space (-1 to 1) to UV space (0 to 1)
    vUv = position * 0.5 + 0.5;
}
